import React from 'react';
interface LogoProps {
  variant?: 'light' | 'dark';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function Logo({
  variant = 'light',
  size = 'md',
  className = ''
}: LogoProps) {
  const isLight = variant === 'light';
  const sizeConfig = {
    sm: {
      gmText: 'text-3xl',
      subText: 'text-[9px]',
      padding: 'px-5 py-2',
      gap: 'mt-1',
      tracking: 'tracking-[0.35em]',
      borderWidth: 'border'
    },
    md: {
      gmText: 'text-5xl',
      subText: 'text-[11px]',
      padding: 'px-7 py-3',
      gap: 'mt-2',
      tracking: 'tracking-[0.4em]',
      borderWidth: 'border'
    },
    lg: {
      gmText: 'text-6xl',
      subText: 'text-xs',
      padding: 'px-8 py-4',
      gap: 'mt-2.5',
      tracking: 'tracking-[0.45em]',
      borderWidth: 'border'
    }
  };
  const s = sizeConfig[size];
  const goldColor = isLight ? 'text-gold' : 'text-gold';
  const borderColor = isLight ? 'border-gold/40' : 'border-bone/30';
  const subColor = isLight ? 'text-gold/80' : 'text-bone/70';
  return <div className={`inline-flex flex-col items-center ${className}`} data-id="element-136" data-mp="1evjfuzqio15e">
      {/* G&M in frame */}
      <div className={`${s.padding} ${s.borderWidth} ${borderColor} inline-block`} data-id="element-137" data-mp="19xhs41i5bdnl">
        <span className={`font-serif font-bold ${s.gmText} ${goldColor} leading-none`} style={{
        textShadow: isLight ? '0 1px 3px rgba(198, 165, 112, 0.3), 0 0 1px rgba(198, 165, 112, 0.15)' : '0 1px 4px rgba(0,0,0,0.4), 0 0 2px rgba(198, 165, 112, 0.2)'
      }} data-id="element-138" data-mp="1nx0wcj7u64um">
          G<span className="text-[0.85em]" data-id="element-139" data-mp="27jfdq7rtnz3r">&</span>M
        </span>
      </div>

      {/* CARPINTERÍA subtitle */}
      <span className={`font-sans font-medium ${s.subText} ${subColor} ${s.tracking} ${s.gap} uppercase block`} data-id="element-140" data-mp="22k2gqu78lbng">
        Carpintería
      </span>
    </div>;
}